import { render, staticRenderFns } from "./PropertyFloorEditor.vue?vue&type=template&id=536b830c&scoped=true&lang=pug&"
import script from "./PropertyFloorEditor.vue?vue&type=script&lang=ts&"
export * from "./PropertyFloorEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PropertyFloorEditor.vue?vue&type=style&index=0&id=536b830c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536b830c",
  null
  
)

export default component.exports